import restApi from "../../http.js";
import session from "../session";

export default class ImageApi {
  //   getClientKeys() {
  //     return restApi({
  //       method: "GET",
  //       url: "/keys/client",
  //       headers: {
  //         Authorization: "Bearer " + session.getAccessToken(),
  //       },
  //     });
  //   }

  static uploadImage(data) {
    return restApi({
      method: "POST",
      url: "/images",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
      data,
    });
  }

  static updateImage(data, id) {
    return restApi({
      method: "PATCH",
      url: `/images/${id}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
      data,
    });
  }

  static deleteImage(id) {
    return restApi({
      method: "DELETE",
      url: `/images/${id}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}

export const ImageStatus = {
  PENDING: "PENDING",
  UPLOADING: "UPLOADING",
  UPLOADED: "UPLOADED",
  FAILED: "FAILED",
};
